import React from 'react'
import { Container, Typography, Skeleton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import { UserApiEndpoints } from '@configuration/apiEndpoints';

import AboutUsHero from '@assets/image/about-us-hero.png'

import { AssetUrl } from '@configuration/apiEndpoints'

import "./aboutUs.css";

export default function AboutUs() {
  const { t } = useTranslation()

  const { isFetching, error, data, isError } = useQuery({
    queryKey: ['getApplication'],
    queryFn: async () =>{
      const [res1, res2, res3, res4] = await Promise.all([
        axios.get(UserApiEndpoints.getAboutUsSection1, { requiresAuth: false }),
        axios.get(UserApiEndpoints.getAboutUsSection2, { requiresAuth: false }),
        axios.get(UserApiEndpoints.getAboutUsSection3, { requiresAuth: false }),
        axios.get(UserApiEndpoints.getAboutUsSection4, { requiresAuth: false }),
      ]);

      return {
        section1: res1.data,
        section2: res2.data,
        section3: res3.data,
        section4: res4.data,
      };
    },
    initialData: null,
    // select: (res) => res?.data || [],
  })

  // console.log(data)

  const isSkeleton = !(data);

  return (
    <div>
      <Container className='about-section-1' maxWidth='lg'>
        <div style={{flex: 1}}>
          <Typography className='title' color='#414042'>
            {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : data?.section1[`header${t('param')}`]}
          </Typography>
          <Typography className='description' color='#414042' textAlign={'justify'}>
            {isSkeleton ? <Skeleton variant='rounded' height={'400px'} animation={!isError && 'pulse'}/> : data?.section1[`content${t('param')}`]}
          </Typography>
        </div>
        <div style={{flex: 1}}>
          {isSkeleton ? <Skeleton variant='rectangular' width={'100%'} height={'100%'} style={{aspectRatio: "111/121"}} animation={!isError && 'pulse'}/> :
            <img src={AboutUsHero} width={'100%'} style={{aspectRatio: "111/121"}} alt='about us'/>
          }
        </div>
      </Container>
      <div style={{backgroundColor: '#FFFFFF'}}>
        <Container className='about-section-2' maxWidth='lg'>
          <div style={{flex: 1}}>
            {isSkeleton ? <Skeleton variant='rectangular' width={'100%'} height={'100%'} style={{aspectRatio: "8 / 11"}} animation={!isError && 'pulse'}/> :
              <img src={`${AssetUrl}${data?.section2?.imagePath}`} width={'100%'} style={{aspectRatio: "8 / 11"}} alt='profile'/>
            }
          </div>
          <div style={{flex: 2, width: '100%'}}>
            <Typography className='tagline' color='#414042'>
              {isSkeleton ? <Skeleton variant='text' width={"100%"} animation={!isError && 'pulse'}/> : data?.section2[`tagline${t('param')}`]}
            </Typography>
            <Typography className='title'>
              {isSkeleton ? <Skeleton variant='text' width={"100%"} animation={!isError && 'pulse'}/> : data?.section2[`header${t('param')}`]}
            </Typography>
            <div className='divider'/>
            <Typography className='description'>
              {isSkeleton ? <Skeleton variant='rounded' height={'300px'} width={"100%"} animation={!isError && 'pulse'}/> : data?.section2[`content${t('param')}`]}
            </Typography>
          </div>
        </Container>
      </div>
      <Container className='about-section-3' maxWidth='md'>
        <Typography className='title'>
          {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : data?.section3[`header${t('param')}`]}
        </Typography>
        <div className='divider'/>
        <Typography className='description'>
          {isSkeleton ? <Skeleton variant='rounded' height={"50px"} animation={!isError && 'pulse'}/> : data?.section3[`content${t('param')}`]}
        </Typography>
        <div className='card-wrapper'>
          {isSkeleton ? <Skeleton variant='rounded' height={"175px"} width={"100%"} animation={!isError && 'pulse'}/> :
            <div className='card' style={{backgroundColor: '#7FA7AC'}}>
              <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                <div className='divider-vertical'/>
                <Typography className='card-title'>
                  {t('about-page.objective')}
                </Typography>
              </div>
              <Typography className='card-desc'>
                {data?.section3[`objective${t('param')}`]}
              </Typography>
            </div>
          }
          {isSkeleton ? <Skeleton variant='rounded' height={"175px"} width={"100%"} animation={!isError && 'pulse'}/> :
            <div className='card' style={{backgroundColor: '#9DBBBF'}}>
              <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                <div className='divider-vertical'/>
                <Typography className='card-title'>
                  {t('about-page.mission')}
                </Typography>
              </div>
              <Typography className='card-desc'>
                {data?.section3[`mission${t('param')}`]}
              </Typography>
            </div>
          }
          {isSkeleton ? <Skeleton variant='rounded' height={"175px"} width={"100%"} animation={!isError && 'pulse'}/> :
            <div className='card' style={{backgroundColor: '#BBD0D3'}}>
              <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                <div className='divider-vertical'/>
                <Typography className='card-title'>
                  {t('about-page.vision')}
                </Typography>
              </div>
              <Typography className='card-desc'>
                {data?.section3[`vision${t('param')}`]}
              </Typography>
            </div>
          }
        </div>
      </Container>
      <Container className='about-section-4' maxWidth='md'>
        <div style={{display: 'flex', gap: 20}}>
          <div className='divider-mobile'/>
          <div className='title-wrapper'>
            <Typography className='tagline' color='#414042'>
              {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : data?.section4[`tagline${t('param')}`]}
            </Typography>
            <Typography className='title' color='#414042'>
              {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : data?.section4[`header${t('param')}`]}
            </Typography>
          </div>
        </div>
        <div className='divider'/>
        <div className='content-wrapper'>
          <div style={{display: 'flex', gap: '10px'}}>
            <div style={{flex: 1}}>
              <Typography className='label' color='#414042'>
                {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : t('about-page.president')}
              </Typography>
            </div>
            <div style={{flex: 1.5}}>
              <Typography className='value'>
                {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : data?.section4[`president${t('param')}`]}
              </Typography>
            </div>
          </div>
          <div style={{display: 'flex', gap: '10px'}}>
            <div style={{flex: 1}}>
              <Typography className='label' color='#414042'>
                {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : t('about-page.vicePresident')}
              </Typography>
            </div>
            <div style={{flex: 1.5}}>
              <Typography className='value'>
                {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : data?.section4[`vicePresident${t('param')}`]}
              </Typography>
            </div>
          </div>
          <div style={{display: 'flex', gap: '10px'}}>
            <div style={{flex: 1}}>
              <Typography className='label' color='#414042'>
                {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : t('about-page.secretary')}
              </Typography>
            </div>
            <div style={{flex: 1.5}}>
              <Typography className='value'>
                {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : data?.section4[`secretary${t('param')}`]}
              </Typography>
            </div>
          </div>
          <div style={{display: 'flex', gap: '10px'}}>
            <div style={{flex: 1}}>
              <Typography className='label' color='#414042'>
                {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : t('about-page.treasurer')}
              </Typography>
            </div>
            <div style={{flex: 1.5}}>
              <Typography className='value'>
                {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : data?.section4[`treasurer${t('param')}`]}
              </Typography>
            </div>
          </div>
          <div style={{display: 'flex', gap: '10px'}}>
            <div style={{flex: 1}}>
              <Typography className='label' color='#414042'>
                {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : t('about-page.boardMembers')}
              </Typography>
            </div>
            <div style={{flex: 1.5}}>
              <Typography className='value'>
                {isSkeleton ? <Skeleton variant='text' animation={!isError && 'pulse'}/> : data?.section4[`boardMember${t('param')}`]}
              </Typography>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}
